import Dashboard from './dashboard'
import Groups from './groups'
import Profile from './profile'
import Students from './students'
import Teachers from './teachers'
import Users from './users'
class Services {
	constructor() {
		this.students = new Students()
		this.teachers = new Teachers()
		this.dashboard = new Dashboard()
		this.profile = new Profile()
		this.users = new Users()
		this.groups = new Groups()
	}
}
const services = new Services()
export default services
